import type { IdentityContext, TenantAccess, TenantContext } from "@broadview/api-client";

/** Demo access uses the already-verified Portal identity and selected membership. */
export function lovableDemoMembership(
  tenant: TenantContext,
  identity: IdentityContext | undefined,
  memberships: readonly TenantAccess[] | undefined,
): TenantAccess | null {
  if (!identity?.userId || !tenant.permissions.includes("problem_record.read")) return null;
  const membership = memberships?.find(
    (item) =>
      item.tenantId === tenant.tenantId &&
      item.subscriberAccountId === tenant.subscriberAccountId &&
      item.permissions.includes("problem_record.read"),
  );
  if (!membership?.membershipId) return null;
  const confirmed = identity.tenants.some(
    (item) =>
      item.tenantId === membership.tenantId &&
      item.membershipId === membership.membershipId &&
      item.subscriberAccountId === membership.subscriberAccountId,
  );
  return confirmed ? membership : null;
}

export function isLovableDemoPath(pathname: string): boolean {
  return pathname === "/demo" || pathname.startsWith("/demo/");
}
